import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from 'posthog-js/react'
import App from "./App";
import "./index.css";
import { UserProvider } from './Components/UserContext';
import { APIProvider } from '@vis.gl/react-google-maps';
import posthog from 'posthog-js'

// Tymczasowo używamy bezpośrednich wartości zamiast zmiennych środowiskowych
const POSTHOG_KEY = 'phc_WwwOv6EXzSmLXn6de7hq4GdivmI67gif93i4dURqljk';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

// Initialize PostHog
posthog.init(
  POSTHOG_KEY,
  {
    api_host: POSTHOG_HOST,
    loaded: (posthog) => {
      if (import.meta.env.DEV) console.log('PostHog loaded', posthog);
    },
    autocapture: true,
    capture_pageview: true,
    capture_performance: true,
    persistence: 'localStorage',
    bootstrap: {
      distinctID: localStorage.getItem('username') || 'anonymous',
      isIdentifiedID: true
    }
  }
);

// Włącz nagrywanie sesji
posthog.startSessionRecording();

// Dodaj debug mode w development
if (import.meta.env.DEV) {
  posthog.debug();
}

// Dodaj console.log aby sprawdzić wartości
console.log('PostHog Key:', POSTHOG_KEY);
console.log('PostHog Host:', POSTHOG_HOST);

// Initialize Sentry
Sentry.init({
  dsn: "https://ad6938e36d0e955c0a953489680467e8@o4508139987533824.ingest.de.sentry.io/4508139993759824",
  integrations: [],
});

const container = document.getElementById("root");
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <APIProvider 
        apiKey={'AIzaSyAbn9Fx_pzsqx1w8Ynsy7sZs28DV7o9uk8'} 
        onLoad={() => console.log('Maps API has loaded.')}
        libraries={['marker']}
      >
        <UserProvider>
          <App />
        </UserProvider>
      </APIProvider>
    </PostHogProvider>
  </React.StrictMode>
);
